module.exports = __webpack_public_path__ + "img/innovations@2x.979866ad.jpg";